import {
  DeadlineExtensionOptionsDto,
  DeadlineExtensionOptionDto,
  DeadlineExtensionOptionItemDto,
} from 'types/dtos/deadline-extension-options'
import {
  DeadlineExtensionOptionsModel,
  DeadlineExtensionOptionModel,
  DeadlineExtensionOptionItemModel,
} from 'types/models/deadline-extension-options'

export const transformDeadlineExtensionOptionItemDto = ({
  name,
  image_url,
}: DeadlineExtensionOptionItemDto): DeadlineExtensionOptionItemModel => ({
  name,
  imageUrl: image_url,
})

export const transformDeadlineExtensionOptionDto = ({
  key,
  title,
  new_shipping_deadline,
}: DeadlineExtensionOptionDto): DeadlineExtensionOptionModel => ({
  key,
  title,
  newShippingDeadline: new_shipping_deadline,
})

export const transformDeadlineExtensionOptionsDto = ({
  items,
  current_shipping_deadline,
  deadline_options,
}: DeadlineExtensionOptionsDto): DeadlineExtensionOptionsModel => ({
  items: items.map(transformDeadlineExtensionOptionItemDto),
  currentShippingDeadline: current_shipping_deadline,
  deadlineOptions: deadline_options.map(transformDeadlineExtensionOptionDto),
})
